export default "import request from \"@/utils/request\"\n\nexport function getData(){\n\n    return request.get(\"/todos\")\n\n}\n\n";